import { ArrowRight, CheckCircle, Package, Truck, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import ageWarningBadge from "@/assets/age-warning.svg";

// P0 Performance: Optimized LCP with background image, minimal DOM
// Using public folder images for proper preloading
const heroBgDesktop = "/images/hero-bg-cannabis.webp";
const heroBgMobile = "/images/hero-bg-cannabis-mobile.webp";

export const Hero = () => {
  return (
    <section className="relative min-h-[85svh] md:min-h-[90vh] flex flex-col">
      {/* Background image - LCP element */}
      <div className="absolute inset-0">
        <picture>
          <source 
            media="(max-width: 767px)" 
            srcSet={heroBgMobile}
          />
          <source 
            media="(min-width: 768px)" 
            srcSet={heroBgDesktop}
          />
          <img 
            src={heroBgDesktop}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
            loading="eager"
            decoding="async"
            fetchPriority="high"
            width={1920}
            height={1080}
            sizes="100vw"
          />
        </picture>
        {/* Overlay for text readability on dark hero */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>
      
      {/* Main content - centered overlay */}
      <div className="flex-1 flex items-center justify-center relative z-10">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-3xl mx-auto text-center">
            
            {/* Main headline - dark text for light background */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-white drop-shadow-lg">
              Köp THCA i Sverige
              <br />
              <span className="bg-gradient-to-r from-primary via-gold to-primary bg-clip-text text-transparent drop-shadow-none">
                THCA Vapes, Buds & Hash Online
              </span>
            </h1>
            
            {/* Subheadline */}
            <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed drop-shadow">
              Noggrant testade, juridiskt verifierade och alltid 100% lagligt.
              <br className="hidden sm:block" />
              Din trygghet först.
            </p>

            {/* Single clear CTA */}
            <div className="flex justify-center mb-10">
              <Link
                to="/kollektioner/alla-produkter"
                className="inline-flex items-center justify-center gap-2 px-10 py-4 text-lg font-bold rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/30 transition-all duration-200 min-w-[200px]"
              >
                Handla Nu
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
            
            {/* 18+ Badge */}
            <div className="flex justify-center">
              <img
                src={ageWarningBadge}
                alt="18+ Åldersgräns"
                className="w-16 h-16 md:w-20 md:h-20"
                title="Denna produkt säljs endast till personer över 18 år"
              />
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};
